import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './AppRoutes.js';
import { AuthProvider } from './lib/auth.js';
import { FeatureFlagsProvider } from './lib/feature-flags.js';

export function App() {
  return (
    <FeatureFlagsProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </FeatureFlagsProvider>
  );
}
